import { type LucideProps } from 'lucide-react';
import { forwardRef } from 'react';

export const Telegram = forwardRef<SVGSVGElement, LucideProps>(
  ({ className }, ref) => {
    return (
      <svg
        ref={ref}
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      >
        <path stroke='none' d='M0 0h24v24H0z' fill='none' />
        <path d='M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4' />
      </svg>
    );
  }
);
